import React, { FC } from 'react';

import { FlexItem } from '../../../Flex';
import AppLayoutRow from '../../AppLayoutRow';

import { getClassNames } from './HeaderRow.styles';
import { headerHeight } from './HeaderRow.types';

const HeaderRow: FC = ({ children }) => {
  const classNames = getClassNames();

  if (!children) {
    return null;
  }

  return (
    <AppLayoutRow height={headerHeight} shrink={0}>
      <FlexItem grow={1} className={classNames.header}>
        {children}
      </FlexItem>
    </AppLayoutRow>
  );
};

export default HeaderRow;
